import React from "react";
import { motion } from "framer-motion"; // ⬅️ import Framer Motion
import StatsRow from "../../components/coach/StatsRow";
import UserListCard from "../../components/coach/UserListCard";
import RecentActivityCard from "../../components/coach/RecentActivityCard";
import PerformanceChartCard from "../../components/coach/PerformanceChartCard";

const DashboardOverviewView = () => {
  const placeholderStats = {
    totalBakelistes: 20,
    bestScores: 1456,
    successRate: 70,
  };

  const placeholderUsersFroid = [
    {
      id: 1,
      name: "Mamadou diallo",
      image: "/avatar.png",
      meta: "Aucun quizz tenté depuis 7 jours",
    },
    {
      id: 2,
      name: "Amadou diallo",
      image: "/avatar.png",
      meta: "Aucun quizz tenté depuis 7 jours",
    },
    {
      id: 3,
      name: "Jean diallo",
      image: "/avatar.png",
      meta: "Aucun quizz tenté depuis 7 jours",
    },
  ];

  const placeholderUsersChaud = [
    {
      id: 1,
      name: "Aliou dia",
      image: "/avatar.png",
      meta: "5 quizz complétés cette semaine",
    },
    {
      id: 2,
      name: "Mo drame",
      image: "/avatar.png",
      meta: "Taux de réussite 92%",
    },
  ];

  const placeholderUsersConvertis = [];

  const placeholderActivities = [
    {
      id: 1,
      user: { avatar: "/avatar.png", name: "Aliou Dia" },
      text: 'Aliou Dia a terminé le quiz "Html" - 92%',
    },
    {
      id: 2,
      user: { avatar: "/avatar.png", name: "Amadou diallo" },
      text: 'Amadou diallo a échoué au test "react"',
    },
    {
      id: 3,
      user: { avatar: "/avatar.png", name: "Mamadou Diallo" },
      text: "Mamadou Diallo a gagné 1 niveau",
    },
  ];

  const fadeUp = {
    hidden: { opacity: 0, y: 20 },
    visible: (i = 1) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1, duration: 0.5, ease: "easeOut" },
    }),
  };

  return (
    <>
      {/* Stats Row Component */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeUp}
        custom={0}
      >
        <StatsRow
          totalBakelistes={placeholderStats.totalBakelistes}
          bestScores={placeholderStats.bestScores}
          successRate={placeholderStats.successRate}
        />
      </motion.div>

      {/* User Lists Grid */}
      <div className="user-lists-grid grid gap-4 mt-6 md:grid-cols-3">
        {[
          { title: "Froid", users: placeholderUsersFroid, icon: "😠" },
          { title: "Chaud", users: placeholderUsersChaud, icon: "😊" },
          { title: "Convertis", users: placeholderUsersConvertis, icon: "↪️" },
        ].map((list, index) => (
          <motion.div
            key={list.title}
            initial="hidden"
            animate="visible"
            variants={fadeUp}
            custom={index + 1} // pour créer un petit délai entre chaque carte
          >
            <UserListCard
              title={list.title}
              statusIcon={list.icon}
              users={list.users}
            />
          </motion.div>
        ))}
      </div>

      {/* Bottom Dashboard Grid */}
      <div className="bottom-dashboard-grid grid gap-4 mt-6 md:grid-cols-2">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeUp}
          custom={4}
        >
          <RecentActivityCard activities={placeholderActivities} />
        </motion.div>
        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeUp}
          custom={5}
        >
          <PerformanceChartCard />
        </motion.div>
      </div>
    </>
  );
};

export default DashboardOverviewView;
